module.exports = __webpack_public_path__ + "img/onetap_transparent.0d01dfb9.png";